import { z } from "@hono/zod-openapi";

// Standard pagination query parameters
export const zPaginationQuery = z.object({
	page: z.coerce
		.number()
		.min(1, "Page number must be at least 1")
		.optional()
		.default(1)
		.openapi({
			description: "Page number (starting from 1)",
			example: 1,
		}),
	pageSize: z.coerce
		.number()
		.min(1, "Page size must be at least 1")
		.max(100, "Page size cannot exceed 100")
		.optional()
		.default(10)
		.openapi({
			description: "Number of items per page (1-100)",
			example: 10,
		}),
	orderBy: z.string().optional().default("createdAt").openapi({
		description: "Field to sort by",
		example: "createdAt",
	}),
	orderDir: z.enum(["asc", "desc"]).optional().default("desc").openapi({
		description: "Sort direction (ascending or descending)",
		example: "desc",
	}),
});

const zPaginated = z.object({
	page: z.number(),
	totalPages: z.number(),
});

export function zPaginate<T extends z.ZodTypeAny>(item: T) {
	return zPaginated.extend({
		items: z.array(item),
	});
}
